import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionItem } from '../../constants/types';
import { PRINT_DOWNLOAD_ICON } from '../print-download-icon/print-download-icon.component';

@Component({
    selector: 'isophi-action-popup',
    templateUrl: './action-popup.component.html',
    styleUrls: ['./action-popup.component.scss'],
    standalone: false
})
export class ActionPopupComponent {
  @Input() actionItems: ActionItem[] = [];
  @Input() primary = false;
  @Output() action = new EventEmitter<ActionItem>();

  protected readonly printDownloadIcon = PRINT_DOWNLOAD_ICON;
}
